const initialState = {
  distinctAdvisors: [],
};

export function fetchDistinctAdvisors(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_DISTINCT_ADVISORS.SUCCESS':
      return {
        ...state,
        distinctAdvisors:  action.advisors,
      };
    default:
      return state
  }
}

